export default __webpack_public_path__ + "img/02.682e643e.jpg";